import React from 'react';
import { Modal } from 'antd';
import { IconFont } from '../../component/icon-font';
import './permission-request-modal.scss';

interface PermissionRequestModalProps {
  visible: boolean;
  type: 'microphone' | 'camera' | 'both';
  onRequestPermission: () => void;
  onCancel: () => void;
}

const PermissionRequestModal: React.FC<PermissionRequestModalProps> = ({
  visible,
  type,
  onRequestPermission,
  onCancel
}) => {
  const isMicrophone = type === 'microphone' || type === 'both';
  const isCamera = type === 'camera' || type === 'both';

  const getTitle = () => {
    if (type === 'microphone') {
      return 'Do you want people to hear you in the meeting?';
    } else if (type === 'camera') {
      return 'Do you want people to see you in the meeting?';
    } else {
      return 'Do you want people to hear and see you in the meeting?';
    }
  };

  const getHint = () => {
    return 'You can still turn off your microphone and camera anytime in the meeting';
  };

  const getButtonText = () => {
    if (type === 'microphone') {
      return 'Use microphone';
    } else if (type === 'camera') {
      return 'Use camera';
    } else {
      return 'Use microphone and camera';
    }
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      className="permission-request-modal"
      width={480}
      centered
      closable={false}
      maskClosable={false}
    >
      <div className="permission-request-content">
        <div className="permission-illustration">
          <div className="illustration-container">
            {/* Illustration placeholder - you can replace with actual illustration */}
            <div className="illustration-person">
              <div className="person-icon"></div>
            </div>
            <div className="illustration-controls">
              {isMicrophone && (
                <div className="control-icon microphone-icon">
                  <IconFont type="icon-audio-unmuted" />
                </div>
              )}
              {isCamera && (
                <div className="control-icon camera-icon">
                  <IconFont type="icon-video-unmuted" />
                </div>
              )}
            </div>
            <div className="illustration-participants">
              {Array.from({ length: 9 }).map((_, i) => (
                <div key={i} className="participant-avatar"></div>
              ))}
            </div>
          </div>
        </div>
        <div className="permission-text">
          <h2 className="permission-title">{getTitle()}</h2>
          <p className="permission-hint">{getHint()}</p>
        </div>
        <div className="permission-actions">
          <button
            className="permission-primary-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRequestPermission();
            }}
          >
            {isMicrophone && <IconFont type="icon-audio-unmuted" />}
            <span>{getButtonText()}</span>
          </button>
          <button
            className="permission-secondary-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCancel();
            }}
          >
            Continue without {type === 'microphone' ? 'microphone' : type === 'camera' ? 'camera' : 'microphone and camera'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PermissionRequestModal;

